import {
  EDIT_ESTIMACION,
  CREATE_ESTIMACION,
  SELECT_ESTIMACION,
  TOGGLE_ESTIMACIONES,
  ESTIMACIONES_RECIBIDAS,
  SET_PROPERTY_ESTIMACION,
  CLEAR_ESTIMACION,
  SET_PROPIEDAD_ESTIMACION,
  SHOW_CACHED_ESTIMACION,
} from "../types/estimaciones";

// Merge a full (conceptos-loaded) estimacion + its acumulados onto the matching
// item in the estimaciones list so it stays cached across accordion toggles.
const cacheEstimacion = (estimaciones, estimacion, acumulados) => {
  if (!Array.isArray(estimaciones)) return estimaciones;
  return estimaciones.map((item) =>
    item.idEstimacion === estimacion.idEstimacion
      ? { ...item, ...estimacion, acumulados }
      : item
  );
};

// A cached item is one that already carries its conceptos (the list endpoint
// only returns summaries, without conceptos).
const findCachedEstimacion = (estimaciones, idEstimacion) => {
  if (!Array.isArray(estimaciones)) return null;
  const cached = estimaciones.find(
    (item) => item.idEstimacion === idEstimacion
  );
  return cached && Array.isArray(cached.conceptos) ? cached : null;
};

const getPrevious = (partidas, conceptos, conceptosExtra) => {
  let prevConceptos = conceptos;
  let prevPartidas = partidas;
  let prevExtras = conceptosExtra;
  if (prevConceptos === null || !prevConceptos) prevConceptos = [];
  if (prevPartidas === null || !prevPartidas) prevPartidas = [];
  if (prevExtras === null || !prevExtras) prevExtras = [];
  prevConceptos = JSON.parse(JSON.stringify([...prevConceptos]));
  prevPartidas = JSON.parse(JSON.stringify([...prevPartidas]));
  prevExtras = JSON.parse(JSON.stringify([...prevExtras]));
  return { prevConceptos, prevPartidas, prevExtras };
};

const EstimacionesReducer = (state, { type, payload }) => {
  switch (type) {
    //Estimaciones
    case SELECT_ESTIMACION:
      const { estimacion, conceptos, acumulados } = payload;
      let currentConceptos =
        state.prevConceptos !== null ? state.prevConceptos : state.conceptos;
      //Initialize tu Array
      if (currentConceptos === null || !currentConceptos) {
        currentConceptos = [];
      }
      //Deep clone of conceptos
      currentConceptos = JSON.parse(JSON.stringify([...currentConceptos]));
      let conceptosEstimacion = JSON.parse(
        JSON.stringify([...currentConceptos])
      );
      //Initialize tu Array
      if (conceptosEstimacion === null || !conceptosEstimacion) {
        conceptosEstimacion = [];
      }
      //Append estimate information
      conceptosEstimacion = conceptosEstimacion.map((concepto) => {
        let conceptoEstimado = conceptos.find(
          (conceptoEst) => conceptoEst.idConcepto === concepto.idConcepto
        );
        if (conceptoEstimado) {
          concepto = {
            ...concepto,
            ...conceptoEstimado,
            idEstimacion: estimacion.idEstimacion,
          };
        }
        return concepto;
      });
      // Always cache the full estimacion in the list so reopening is instant.
      const estimacionesCache = cacheEstimacion(
        state.estimaciones,
        estimacion,
        acumulados
      );
      // Only surface as the active estimacion if it's still the one last
      // opened — a slow earlier fetch must not clobber a newer selection.
      const isCurrent =
        state.selectedId == null ||
        // Loose equality: selectedId comes from the URL params (string) while
        // estimacion.idEstimacion comes from the API (number), so a strict
        // comparison would always fail on a deep-link and leave estimacion null.
        // eslint-disable-next-line eqeqeq
        state.selectedId == estimacion.idEstimacion;
      return {
        ...state,
        estimaciones: estimacionesCache,
        ...(isCurrent ? { estimacion, acumulados } : {}),
        conceptos: conceptosEstimacion,
        ...getPrevious(state.partidas, state.conceptos),
      };
    case SHOW_CACHED_ESTIMACION: {
      // Opening an accordion: remember which one is selected and, if we already
      // have it cached, show it immediately while the newest version fetches.
      const idEstimacion = payload;
      const cached = findCachedEstimacion(state.estimaciones, idEstimacion);
      return {
        ...state,
        selectedId: idEstimacion,
        estimacion: cached ? cached : null,
        acumulados: cached ? cached.acumulados : state.acumulados,
      };
    }
    case CLEAR_ESTIMACION:
      return {
        ...state,
        estimacion: null,
        partidas: state.prevPartidas,
        conceptos: state.prevConceptos,
      };
    case ESTIMACIONES_RECIBIDAS:
      return { ...state, estimaciones: payload };
    case TOGGLE_ESTIMACIONES:
      return { ...state, showEstimaciones: !state.showEstimaciones };
    case EDIT_ESTIMACION:
      let editMode = "estimacion";
      if (payload === null) editMode = null;
      return {
        ...state,
        editMode,
        estimacionEditada: payload,
      };
    case CREATE_ESTIMACION:
      const numero =
        state.estimaciones !== null ? state.estimaciones.length + 1 : 1;
      return {
        ...state,
        estimacionEditada: { idEstimacion: "nueva", fecha: "", numero },
      };
    case SET_PROPERTY_ESTIMACION: {
      const estimacionEditada = { ...state.estimacionEditada };
      estimacionEditada[payload.key] = payload.value;
      return { ...state, estimacionEditada };
    }
    case SET_PROPIEDAD_ESTIMACION: {
      const estimacion = { ...state.estimacion };
      estimacion[payload.key] = payload.value;
      return { ...state, estimacion };
    }
    default:
      return { ...state };
  }
};
export default EstimacionesReducer;
